import HumberInput from './humber-input';

export default HumberInput;
